<template>
  <v-flex xs12 md6 lg4 class="padContainer">
    <v-card @click.native="lItem.show = !lItem.show" style="width: 100%;margin-bottom: 1px;" :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode'}">
      <v-container fluid style="padding: 10px;">

        <v-card-text style="padding: 2px;">
          <v-layout wrap>
            <v-flex xs6>
              <div style="font-size: 1.3em;">{{lItem.name}}</div>
            </v-flex>
            <v-flex xs6 style="text-align:right;">
              <span v-if="lItem.date !== ''">{{ lItem.date }}</span>
              <span v-if="lItem.type !== '' && lItem.date === ''">{{ lItem.type }}</span>
            </v-flex>
            <v-flex xs12 style="text-align:right;">
              <span>{{lItem.currency}} {{lItem.amount}}</span>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-dialog v-model="lItem.show" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar flat>

              <v-toolbar-title>{{lItem.name}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon flat @click.native="lItem.show = false"><v-icon>fas fa-backspace</v-icon></v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-toolbar flat style="width:170px;margin-left: auto;margin-right: auto;border-radius: 0 0 28px 28px;">
              <v-btn icon class="mx-0" v-on:click.prevent="redirectToEditPage(lItem.id)" style="margin-left: 15px !important;">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn icon class="mx-0" v-on:click.prevent="DeleteItem(lItem.id)" style="margin-right: 15px !important;">
                <v-icon color="error">delete</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text style="height: 100%;">
              <AccountData v-if="liItem.type === 'account'" v-bind:accountId="lItem.id"></AccountData>
              <BudgetData v-if="liItem.type === 'budget'" v-bind:budgetId="lItem.id"></BudgetData>
              <TransferData v-if="liItem.type === 'transfer'" v-bind:transferId="lItem.id"></TransferData>

            </v-card-text>

          </v-card>
        </v-dialog>

      </v-container>
    </v-card>
    </v-flex>
</template>

<script>
  import AccountData from '../../account/AccountData.vue'
  import BudgetData from '../../budget/BudgetData.vue'
  import TransferData from '../../transfer/TransferData.vue'

  export default {
    components: {
      'AccountData': AccountData,
      'BudgetData': BudgetData, 
      'TransferData': TransferData
    },
    props: ['liItem'],
    data() {
      return {
        lItem: {
          id: 0,
          name: '',
          account: '',
          type: '',
          amount: 0,
          amountSpent: 0,
          refillAmount: 0,
          date: '',
          currency: '',

          show: false
        }
      }
    },
    methods: {
      redirectToEditPage: function (itemId) {
        this.$emit('Edit', itemId)
      },
      DeleteItem: function (lItem) {
        this.$emit('Delete', lItem)
      },
      conversionManager: function(type, data) {
        switch (type) {
          case "account":
            this.convertAccountTolItem(data)
            break
          case "income":
            this.convertIncomeTolItem(data)
            break
          case "expense":
            this.convertExpenseTolItem(data)
            break
          case "budget":
            this.convertBudgetTolItem(data)
            break
          case "transfer":
            this.convertTransferTolItem(data)
            break
          case "transaction":
            this.convertTransactionTolItem(data)
            break
        }
      },
      convertAccountTolItem: function (data) {
        this.lItem.id = data.id
        this.lItem.name = data.accountName
        this.lItem.type = data.accountType
        this.lItem.amount = data.accountAmount
        this.lItem.currency = data.accountCurrency
      },
      convertIncomeTolItem: function(data) {
        this.lItem.id = data.id
        this.lItem.name = data.incomeName
        this.lItem.type = data.incomeType
        this.lItem.amount = data.incomeAmount
        this.lItem.currency = data.currency
        this.lItem.account = data.account
        this.lItem.date = data.incomeDate
      },
      convertExpenseTolItem: function(data) {
        this.lItem.id = data.id
        this.lItem.name = data.expenseName
        this.lItem.type = data.expenseType
        this.lItem.amount = data.expenseAmount
        this.lItem.currency = data.currency
        this.lItem.account = data.account
        this.lItem.date = data.expenseDate
      },
      convertBudgetTolItem: function (data) {
        this.lItem.id = data.id
        this.lItem.name = data.budgetName
        this.lItem.type = data.budgetType
        this.lItem.amount = data.budgetAmount
        this.lItem.account = data.account
      },
      convertTransferTolItem: function (data) {
        this.lItem.id = data.id
        this.lItem.name = data.transferName
        this.lItem.amount = data.transferAmount
        this.lItem.currency = data.currency
        this.lItem.account = data.account
        this.lItem.date = data.transferDate
      },
      convertTransactionTolItem: function (data) {
        this.lItem.id = data.id
        this.lItem.name = data.transactionName
        this.lItem.type = data.transactionType
        this.lItem.amount = data.transactionAmount
        this.lItem.currency = data.currency
        this.lItem.account = data.account
        this.lItem.date = data.transactionDate
      }
    },
    beforeMount() {
     this.conversionManager(this.liItem.type, this.liItem.data)
    }
  }

</script>

<style scoped>
  .flex {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .padContainer {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reuseable/viewListItem/listItem.vue